import { useState, useEffect } from 'react';
import { getPrices } from 'services/product.service';
import { getItemDetails } from 'services/pages.svc';
import cart from '../cart';

export default (planId) => {
  const [orderedPlan, setPlan] = useState();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const email = cart.get('email');
  const offers = cart.get('offers') || [];
  useEffect(() => {
    const ids = offers.map((o) => o.product_key || o.key);
    getPrices(ids).then((r) => {
      setPlans(r);
      setLoading(false);
    });
    getItemDetails(planId).then((r) => {
      setPlan(r);
    });
  }, []);

  if (!loading && orderedPlan) {
    const immediate = [];
    const yearly = [];
    const monthly = [];
    let yearlyTotal = 0;
    let monthlyTotal = 0;

    if (orderedPlan.freq === 'month') {
      monthlyTotal = orderedPlan.price;
    } else if (orderedPlan.freq === 'year') {
      yearlyTotal = orderedPlan.price;
    }

    offers.forEach((o) => {
      const planDetails = plans.find(
        (p) => p.stripe_price_id === o.product_key,
      );
      if (planDetails) {
        const d = {
          product_name: planDetails.product.product_name,
          product_amount: +planDetails.price_amount_in_cents / 100,
        };
        if (planDetails.price_frequency === 'yearly') {
          yearly.push(d);
          yearlyTotal = yearlyTotal + d.product_amount;
        } else if (planDetails.price_frequency === 'monthly') {
          monthly.push(d);
          monthlyTotal = monthlyTotal + d.product_amount;
        }
      } else {
        immediate.push(o);
      }
    });

    const immediateTotal = immediate.reduce((memo, i) => {
      return memo + Number(i.offer_cost);
    }, 0);

    return {
      plan: orderedPlan,
      email,
      offers,
      immediate,
      immediateTotal,
      yearly,
      yearlyTotal,
      monthly,
      monthlyTotal,
    };
  }

  return {
    loading: true,
  };
};
